import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Corrigir o problema dos ícones do Leaflet
const DefaultIcon = L.icon({
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

interface MapComponentProps {
  latitude: number;
  longitude: number;
  popupText?: string;
  height?: string | number;
}

const MapComponent: React.FC<MapComponentProps> = ({ 
  latitude, 
  longitude, 
  popupText = 'Localização do Ativo',
  height = 400
}) => {
  // Validar as coordenadas para evitar o erro "Invalid LatLng object: (undefined, undefined)"
  const validLatitude = typeof latitude === 'number' && !isNaN(latitude) ? latitude : -23.550520; // São Paulo como padrão
  const validLongitude = typeof longitude === 'number' && !isNaN(longitude) ? longitude : -46.633308;
  
  const position: [number, number] = [validLatitude, validLongitude];

  return (
    <MapContainer 
      center={position} 
      zoom={15} 
      style={{ height: height, width: '100%' }}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Marker position={position} icon={DefaultIcon}>
        <Popup>
          {popupText}
        </Popup>
      </Marker>
    </MapContainer>
  );
};

export default MapComponent;
